<template>
  <div id="addToCartAnimation" class="add-to-cart-animation-container">
    <div class="ball-container">
      <!--小球-->
      <div v-for="ball in balls">
        <transition name="drop" @before-enter="beforeDrop" @enter="dropping" @after-enter="afterDrop">
          <div class="ball" :style="{left: leftPx + 'px', top: topPx + 'px'}" v-show="ball.show">
            <div class="inner inner-hook"></div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import busUtil from "../../assets/js/util";
import {mapState} from 'vuex'

export default {
  name: "add-to-cart-animation",
  data() {
    return {
      //小球 设为3个
      balls: [{
        show: false
      },
      {
        show: false
      },
      {
        show: false
      }],
      dropBalls: [],
      leftPx: 0,
      topPx: 0,
      item: null,
      count: 0,
      timeoutId: null,
      windowWidthId: null
    }
  },
  computed: {
    ...mapState({
      windowWidth: state => state.navbar.windowWidth,
      isMobile() {
        return this.windowWidth < 800;
      },
    })
  },
  watch: {
    $route() {
      this.afmClearTimeout()
      this.resetCountAndInitBallPos()
    },
    windowWidth() {
      clearTimeout(this.windowWidthId)
      this.windowWidthId = setTimeout(() => {
        this.afmClearTimeout()
        this.resetCountAndInitBallPos()
      }, 880)
    }
  },
  methods: {
    drop(event, item) { //抛物
      this.item = item;
      const el = event.target
      for (let i = 0; i < this.balls.length; i++) {
        let ball = this.balls[i];
        if (!ball.show) {
          ball.el = el;
          ball.show = true;
          this.dropBalls.push(ball);
          return;
        }
      }
    },
    beforeDrop(el) {
      /* 购物车小球动画实现 */
      let count = this.balls.length;
      while (count--) {
        let ball = this.balls[count];
        if (ball.show) {
          let rect = ball.el.getBoundingClientRect(); //元素相对于视口的位置
          let x = parseInt(rect.left - this.leftPx) + parseInt(rect.width/2);
          let y = -(this.topPx - rect.top) + parseInt(rect.height/2); //获取y
          el.style.display = '';
          el.style.transform = 'translateY(' + y + 'px)';
          let inner = el.getElementsByClassName('inner-hook')[0];
          inner.style.transform = 'translateX(' + x + 'px)';
        }
      }
    },
    dropping(el, done) {
      /*重置小球数量  样式重置*/
      const offsetHeight = el.offsetHeight; // 不知原因，必须要有这么一句，否则第一次动画会不触发transitionend回调
      el.style.transform = 'translate3d(0,0,0)';
      let inner = el.getElementsByClassName('inner-hook')[0];
      inner.style.transform = 'translate3d(0,0,0)';
      el.addEventListener('transitionend', done);
    },
    afterDrop(el) {
      /*初始化小球*/
      busUtil.$emit('addToCartAfterDrop', this.item)
      let ball = this.dropBalls.shift();
      if (ball) {
        ball.show = false;
        el.style.display = 'none';
      }
    },
    initBallPosition() {
      let cartIconEl = null
      if (!this.isMobile) {
        cartIconEl = document.getElementById('cart-icon');
      } else {
        cartIconEl = document.getElementById('mobile-cart-icon');
      }
      if (!cartIconEl) {
        this.count++
        if (this.count > 10) {
          return this.afmClearTimeout()
        }
        return this.afmSetTimeout()
      }
      const cartRect = cartIconEl.getBoundingClientRect()
      const cartX = cartRect.left;
      const cartY = cartRect.top;
      if (cartX === 0 || cartY === 0) {
        return this.afmSetTimeout()
      }
      if (cartX === this.leftPx && cartY === this.topPx) {
        return this.afmClearTimeout()
      }
      this.afmClearTimeout()
      this.leftPx = cartX + parseInt(cartRect.width / 2);
      this.topPx = cartY + parseInt(cartRect.height / 2);
    },
    afmSetTimeout() {
      this.afmClearTimeout()
      this.timeoutId = setTimeout(this.initBallPosition, 1000)
    },
    afmClearTimeout() {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    },
    resetCountAndInitBallPos() {
      this.count = 0
      this.initBallPosition()
    },
    initPage() {
      this.resetCountAndInitBallPos()
      busUtil.$on('addToCartDrop', this.drop);
    }
  },
  mounted() {
    this.initPage()
  },
  beforeDestroy() {
    this.afmClearTimeout()
    busUtil.$off("addToCartDrop")
  }
}
</script>

<style lang="less" scoped>
.add-to-cart-animation-container {
  .ball {
    position: fixed;
    z-index: 99999;
    transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
    /*贝塞尔曲线*/
  }

  .inner {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #E9C34B;
    transition: all 0.4s linear;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-to-cart-animation/add-to-cart-animation.vue